import { useQuery } from '@tanstack/react-query';

import { getFlightCampaign } from '~/services/FlightsService';

export const FLIGHT_CAMPAIGN_QUERY_KEY = 'flightCampaign';

export function useFlightCampaign(id: string) {
  const {
    data,
    isLoading: loading,
    error,
    refetch,
  } = useQuery<App.FlightCampaign, Error>({
    queryKey: [FLIGHT_CAMPAIGN_QUERY_KEY, id],
    queryFn: async () => {
      const { result } = await getFlightCampaign(id);
      return result;
    },
    enabled: !!id,
  });

  return { loading, error, data, revalidate: refetch };
}
